import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { heroContent } from '../../data/mock';

// Hero images for responsive display
const heroImages = {
  desktop: 'https://customer-assets.emergentagent.com/job_property-portfolio-14/artifacts/0udo8zdi_Screenshot%202025-02-05%20at%202.38.57%E2%80%AFPM.png',
  mobile: 'https://customer-assets.emergentagent.com/job_property-portfolio-14/artifacts/k0gufi3l_G%20Developments%20%287%29.png'
};

export const HeroSection = () => {
  return (
    <section className="relative min-h-[85vh] flex items-center overflow-hidden">
      {/* Background Images - Responsive with priority loading for LCP */}
      <div className="absolute inset-0">
        {/* Desktop Image - Hidden on mobile */}
        <img
          src={heroImages.desktop}
          alt="G Developments golf resort with lake and palm trees"
          className="hidden md:block w-full h-full object-cover"
          width={1920}
          height={1080}
          loading="eager"
          fetchpriority="high"
          decoding="sync"
        />
        {/* Mobile Image - Hidden on desktop */}
        <img
          src={heroImages.mobile}
          alt="G Developments beachfront resort"
          className="block md:hidden w-full h-full object-cover"
          width={750}
          height={1000}
          loading="eager"
          fetchpriority="high"
          decoding="sync"
        />
        {/* Overlay for text readability */}
        <div className="absolute inset-0 bg-gradient-to-r from-stone-900/80 via-stone-900/50 to-transparent" />
      </div>

      <div className="relative max-w-7xl mx-auto px-6 lg:px-8 py-24">
        <div className="max-w-2xl">
          {/* Eyebrow text with gradient */}
          <span className="inline-block text-xs font-semibold tracking-[0.2em] text-blue-300 uppercase mb-6">
            Premium Real Estate in Egypt
          </span>
          
          {/* Main headline */}
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-light text-white leading-tight mb-8">
            Crafting{' '}
            <span className="font-medium bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent">
              Exceptional
            </span>{' '}
            Living Spaces
          </h1>
          
          {/* Subheadline */}
          <p className="text-lg text-stone-300 leading-relaxed mb-12 max-w-xl">
            {heroContent.subheadline}
          </p>
          
          {/* CTA Button with gradient */}
          <Link
            to="/projects"
            className="group inline-flex items-center gap-3 px-8 py-4 bg-gradient-to-r from-blue-600 to-purple-600 text-white text-sm font-medium tracking-wide rounded-sm hover:from-blue-700 hover:to-purple-700 transition-all duration-300 shadow-lg shadow-purple-500/30 hover:shadow-xl hover:shadow-purple-500/40"
          >
            {heroContent.cta}
            <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform duration-300" />
          </Link>
        </div>
      </div>
    </section>
  );
};
